import React, { Component } from "react";

export interface AnimatedPathProps {
  fill: string;
  d: any;
  animationduration: number;
}

class AnimatedPath extends Component<AnimatedPathProps> {
  component: any;
  newD: any;

  static defaultProps = {
    animationduration: 300,
  };

  constructor(props: AnimatedPathProps) {
    super(props);
    this.state = { d: props.d };
  }
  render() {
    return <path ref={(ref) => (this.component = ref)} {...this.props} />;
  }
}

export default AnimatedPath;
